import { motion } from 'framer-motion';

export default function Step2({
  formData,
  setFormData,
  handleChange,
  nextStep,
  prevStep,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-2xl font-bold text-gray-900 mb-2"
      >
        Your Organization
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-sm font-semibold text-gray-600 mb-6"
      >
        Share your professional details, or skip if you're <br></br> using
        uLegal.ai personally.
      </motion.p>

      <motion.form
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="space-y-4"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            What is your company name? (optional)
          </label>
          <input
            name="companyName"
            type="text"
            value={formData.companyName}
            onChange={(e) => handleChange('companyName', e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            What is your Job Title? (optional)
          </label>
          <input
            name="jobTitle"
            type="text"
            value={formData.jobTitle}
            onChange={(e) => handleChange('jobTitle', e.target.value)}
            className="w-full border border-gray-300 rounded px-4 py-3 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="text-xs text-gray-500 mt-2"
        >
          We use this information for billing, document exports, and
          professional features. You can update it anytime.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="flex justify-end gap-3 mt-6"
        >
          <motion.button
            type="button"
            onClick={prevStep}
            className="px-8 py-2 border border-indigo-500 text-indigo-600 rounded hover:bg-indigo-50 transition font-medium"
          >
            Back
          </motion.button>

          <motion.button
            type="button"
            onClick={nextStep}
            className="px-14 py-2 bg-gradient-to-r from-brandDark to-brand text-white rounded hover:bg-indigo-700 transition font-medium"
          >
            Next
          </motion.button>
        </motion.div>
      </motion.form>
    </motion.div>
  );
}
